
export interface NoiseReductionOptions {
  noiseSuppression?: boolean;
  echoCancellation?: boolean;
  autoGainControl?: boolean;
  sampleRate?: number;
}

export const createNoiseCancellationProcessor = async (
  audioContext: AudioContext,
  options: NoiseReductionOptions = {}
): Promise<AudioWorkletNode> => {
  try {
    // Register the audio worklet processor
    await audioContext.audioWorklet.addModule(
      URL.createObjectURL(
        new Blob([
          `
          class NoiseReductionProcessor extends AudioWorkletProcessor {
            constructor() {
              super();
              this.noiseGate = 0.01; // Threshold for noise gate
              this.smoothingFactor = 0.8;
            }

            process(inputs, outputs, parameters) {
              const input = inputs[0];
              const output = outputs[0];

              if (input.length > 0) {
                for (let channel = 0; channel < input.length; channel++) {
                  const inputChannel = input[channel];
                  const outputChannel = output[channel];
                  
                  for (let i = 0; i < inputChannel.length; i++) {
                    let sample = inputChannel[i];
                    
                    // Simple noise gate
                    if (Math.abs(sample) < this.noiseGate) {
                      sample *= 0.1; // Reduce low-level noise
                    }
                    
                    // Smooth the output
                    outputChannel[i] = sample * this.smoothingFactor;
                  }
                }
              }

              return true;
            }
          }

          registerProcessor('noise-reduction-processor', NoiseReductionProcessor);
          `,
        ], { type: 'application/javascript' })
      )
    );

    // Create the worklet node
    const workletNode = new AudioWorkletNode(audioContext, 'noise-reduction-processor');
    
    return workletNode;
  } catch (error) {
    console.warn('Failed to create noise cancellation processor:', error);
    
    // Fallback: create a simple gain node
    const gainNode = audioContext.createGain();
    gainNode.gain.value = 0.8;
    
    return gainNode as any; // Return as AudioWorkletNode type for compatibility
  }
};
